import { useCallback } from 'react';

import { useToastStore } from '@pkg/components';

export function getErrorMessaging(error?: Partial<Error>): string {
    let errorString = 'There was an error, please try again.';
    const errorMessage = error?.message?.toLowerCase();
    if (errorMessage) {
        const fundsError = errorMessage.includes('balance too low') || errorMessage.includes('insufficient funds');
        const rejectionError = errorMessage.includes('rejected the request');
        if (fundsError) {
            errorString = 'Insufficient funds to proceed with transaction.';
        }
        if (rejectionError) {
            errorString = 'You rejected the request in your wallet.';
        }
    }
    return errorString;
}

export function useMarketplaceToasts({ errorCallback }: { errorCallback?: () => void }) {
    const { addToast } = useToastStore();
    // TODO: possible add loading toast?
    return useCallback(
        (error?: Partial<Error>) => {
            const errorMessage = getErrorMessaging(error);
            addToast({ message: errorMessage, minimal: true, timeout: 4000 });
            errorCallback?.();
        },
        [addToast, errorCallback],
    );
}
